import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { Link } from "react-router-dom";

const KEY = "checkmate-cookie-consent-v1";

/**
 * GDPR/CCPA cookie consent banner — one-shot per browser.
 * `sessionStorage` would drop consent between tabs so we use `localStorage`.
 */
// Stores ONE non-sensitive UI preference in localStorage: the key below,
// holding "essential|all:<timestamp>" so the banner is not shown again. No
// personal data, tokens or session material is ever written here.
export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch {
      /* private browsing — silently skip the banner */
    }
  }, []);
  const accept = (kind) => {
    try { localStorage.setItem(KEY, `${kind}:${Date.now()}`); } catch { /* noop */ }
    setVisible(false);
  };
  if (!visible) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md z-40 border-2 border-ink bg-white shadow-hard-lg p-4" data-testid="cookie-banner">
      <div className="flex items-start gap-3">
        <Cookie className="w-5 h-5 shrink-0 mt-1" />
        <div className="text-xs font-mono leading-relaxed">
          <div className="font-black mb-1">We use essential cookies only.</div>
          <p className="text-muted-foreground">
            Checkmate stores a session cookie so you stay logged in. We do not run ad-tracking or third-party analytics.
            See our <Link to="/legal/privacy" className="underline">Privacy Policy</Link>.
          </p>
          <div className="mt-3 flex gap-2">
            <button data-testid="cookie-accept" onClick={() => accept("accept")} className="hard-btn px-3 py-1 text-[10px] uppercase tracking-widest">Got it</button>
            <button data-testid="cookie-decline" onClick={() => accept("decline")} className="border-2 border-ink px-3 py-1 text-[10px] uppercase tracking-widest">Essential only</button>
          </div>
        </div>
      </div>
    </div>
  );
}
